import AddRatingSystemCont from 'components/Main/RatingSystem/AddRating/AddRatingSystemCont'
import SupportTicket from 'components/Main/SupportTicket/SupportTicket'
import SupportTicketCont from 'components/Main/SupportTicket/ViewSupportTicket/SupportTicketCont'
import UserManagement from 'components/Main/UserManagement/UserManagement'
import UserManagementCont from 'components/Main/UserManagement/ViewUserManagement/UserManagementCont'
import AddWarrantyCont from 'components/Main/Warranty/Warranty/AddWarrantyCont'
import WarrantyCont from 'components/Main/Warranty/WarrantyCont'
import AddNewsletterCont from '../../components/Main/Newsletter/AddNewsletter/AddNewsletterCont'
import AddEmailCont from '../../components/Main/Emails/AddEmail/AddEmailCont'
import ProductCont from '../../components/Main/Product/ProductCont'
import StockCont from '../../components/Main/Stock/StockCont'
import AddTrackingCont from '../../components/Main/Tracking/AddTracking/AddTrackingCont'
import TestCont from '../../components/TestCont'
import React, { Component, lazy, Suspense } from 'react'
import NoMatchComponent from '../../components/NoMatch.jsx'
import { Route, Switch } from 'react-router-dom'
import Dropdowns from '../../modules/Dropdowns'
import AddBudgetCont from '../../components/Common/Budgets/BudgetCont'
import StandardCont from '../../components/Main/Standards/StandardCont'
import CenterSpin from '../../elements/CenterSpin'

import AsyncDashboard from '../../components/Main/Dashboard/Dashboard'
import AsyncCalendar from '../../components/Main/Calendar/Calendar'
import AsyncPhoneBook from '../../components/Main/PhoneBook'
import AsyncAccount from '../../components/Main/Account/AccountCont'
import AsyncNewsletter from '../../components/Main/Newsletter/NewsletterCont'
import AsyncEmails from '../../components/Main/Emails/EmailCont'
import AsyncRating from '../../components/Main/RatingSystem/RatingSystemCont'
import AsyncTrackingCont from '../../components/Main/Tracking/TrackingCont'

export default class MainRouter extends Component {
  constructor(props) {
    super(props)
    this.url = props.match.url
  }

  componentDidMount() {
    new Dropdowns({ dropdown: 'attendance', name: 'status' }).set()
    new Dropdowns({ dropdown: 'employee', name: 'leaves' }).set()
  }

  render() {
    return (
      <Suspense fallback={<CenterSpin fontSize={50} />}>
        <Switch>
          <Route path="/phoneBook" name="phonebook" key="phonebook" component={AsyncPhoneBook} />
          <Route path="/calendar" name="calendar" key="calendar" component={AsyncCalendar} />
          <Route path="/account" name="account" key="account" component={AsyncAccount} />
          <Route path={`${this.url}/`} key="Dashboard" component={AsyncDashboard} />
          <Route path={`/budgets/:collection/:owner/new`} component={AddBudgetCont} />
          <Route path={`/standard`} component={StandardCont} />
          <Route path={`/product`} component={ProductCont} />
          <Route path={`/stock`} component={StockCont} />

          <Route path={`/newsletter/:key/update`} component={AddNewsletterCont} />
          <Route path={`/newsletter/new`} component={AddNewsletterCont} />
          <Route path={`/newsletter`} component={AsyncNewsletter} />

          <Route path={`/warranty/:key/update`} component={AddWarrantyCont} />
          <Route path={`/warranty/new`} component={AddWarrantyCont} />
          <Route path={`/warranty`} component={WarrantyCont} />

          <Route path={`/email/:key/update`} component={AddEmailCont} />
          <Route path={`/email`} component={AsyncEmails} />

          <Route path={`/rating/:key/update`} component={AddRatingSystemCont} />
          <Route path={`/rating`} component={AsyncRating} />

          <Route path={`/tracking/:key/update`} component={AddTrackingCont} />
          <Route path={`/tracking/new`} component={AddTrackingCont} />
          <Route path={`/tracking`} component={AsyncTrackingCont} />

          <Route path={`/test`} component={TestCont} />

          <Route path={`/support/:key/update`} component={SupportTicketCont} />
          <Route path={`/support`} component={SupportTicket} />

          <Route path={`/users/:key/update`} component={UserManagementCont} />
          <Route path={`/users/new`} component={UserManagementCont} />
          <Route path={`/users`} component={UserManagement} />

          <Route key="NoMatchComponent" component={NoMatchComponent} />
        </Switch>
      </Suspense>
    )
  }
}
